import React from 'react'


const Teaser = ({
  title,
  path,
  code,
  type,
  ...props
 }) => (
  <article {...props}>
    <h4>
      <a href={path}>{title}</a>
    </h4>
              {/*<dl>
                {code && (
                  <>
                    <dt>Map code</dt>
                    <dd>{code}</dd>
                  </>
                )}
                </dl>*/}
            </article>
)

export default Teaser;
